import React from "react";

const ProcessingModal = ({ title = "Processing Your Payment", message = "This will only take a moment. Thank you for your patience." }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
        <div className="flex flex-col items-center">
          {/* Loading Spinner */}
          <div className="relative w-16 h-16 mb-6">
            <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">
            {title}
          </h2>

          {/* Message */}
          <p className="text-gray-600 text-center mb-6">
            {message}
          </p>

          {/* Important Notice */}
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 w-full">
            <p className="text-sm text-gray-700">
              <span className="font-semibold text-orange-600">Important:</span>{" "}
              Please do not refresh this page or use the back button while your transaction is being processed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingModal;
